export function getBenefitsText(getStringRes, key) {
  return getStringRes(key);
}
